import React from 'react';

export default () => {
  return (
    <div className="step row">
      {/*Pregunta 25*/}
      <div className="col-md-13">
        <h3>
          25. ¿Cuento con las herramientas, información y materiales necesarios
          para hacer bien mi trabajo?
        </h3>
        <ul className="data-list-2" id="preg25">
          <li>
            <input
              name="preg25"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg25"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg25"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg25"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg25"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 26*/}
      <div className="col-md-12">
        <h3>
          26. ¿Mi lugar de trabajo cuenta con las condiciones físicas adecuadas
          para trabajar?
        </h3>
        <ul className="data-list-2" id="preg26">
          <li>
            <input
              name="preg26"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg26"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg26"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg26"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg26"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 27*/}
      <div className="col-md-12">
        <h3>
          27. ¿En mi trabajo, son abiertos y me motivan a pensar sobre nuevas
          formas de hacer las cosas?
        </h3>
        <ul className="data-list-2" id="preg27">
          <li>
            <input
              name="preg27"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg27"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg27"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg27"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg27"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 28*/}
      <div className="col-md-12">
        <h3>28. ¿Mi día a día en el trabajo es retador e interesante?</h3>
        <ul className="data-list-2" id="preg28">
          <li>
            <input
              name="preg28"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg28"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg28"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg28"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg28"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Step7.jsx